import { render, staticRenderFns } from "./BottomPaginator.vue?vue&type=template&id=5e1f66b7&scoped=true&"
import script from "./BottomPaginator.vue?vue&type=script&lang=js&"
export * from "./BottomPaginator.vue?vue&type=script&lang=js&"
import style0 from "./BottomPaginator.vue?vue&type=style&index=0&id=5e1f66b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1f66b7",
  null
  
)

export default component.exports